import { useContext } from "react";
import { userOnboardingContext } from "../../states/context/userOnboardingContext";
import { styled } from '@mui/material/styles';
import ObjectivesChallengesCheckList from "./common/ObjectivesChallengesCheckList";

const MainContainer = styled('div')(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  marginLeft: "108px",
}));

const ObjHeading = styled('h3')(({ theme }) => ({
  fontSize: "20px",
  fontWeight: "600",
  margin: 0,
  marginBottom: "16px",
  color: '#171717',
}));

const LeftContainer = styled('div')(({ theme }) => ({
  marginRight: "63px",
}));

const HeaderContainer = styled('div')(({ theme }) => ({
  marginTop: "80px",
  marginBottom: '40px',
}));

const WelcomeHeading = styled('h2')(({ theme }) => ({
  fontSize: "32px",
  fontWeight: "600",
  fontFamily: "Figtree",
  marginTop: 0,
  marginBottom: "24px",
  color: '#171717',
}));

const HeadPara = styled('p')(({ theme }) => ({
  fontSize: "16px",
  fontWeight: "400",
  color: "#747474",
  margin: 0,
}));

const KeyObjectives = () => {
  const { user } = useContext(userOnboardingContext);
  const { objectives } = user;

  return (
    <MainContainer>
      <LeftContainer>
        <HeaderContainer>
          <WelcomeHeading>Welcome to Kavida.ai</WelcomeHeading>
          <HeadPara>
            Help us <b>build your personalize AI agent</b> by telling us a
            little bit about yourself, the challenges you are facing, and your
            goals.
          </HeadPara>
        </HeaderContainer>
        <div>
          <ObjHeading>
            What are the key objectives in your current role?
          </ObjHeading>
          <p style={{ color: "#747474", margin: 0 }}>
            Select all that apply from the list below, and add any other
            objective(s) that's not included in the list below. The more
            specific you are, the better Agent PO can assist.
          </p>
        </div>
        <ObjectivesChallengesCheckList
          itemList={objectives}
          addBtnText="objective"
        />
      </LeftContainer>
    </MainContainer>
  );
};

export default KeyObjectives;
